import { useEffect, useState } from 'react'
import { InitPlans } from '../utils'
import { useLocation } from 'react-router-dom'

export default function useSetPlan() {
    const [plans, setPlans] = useState<IPlan[]>(InitPlans)
    const [selectedplan, setSelectedPlan] = useState<number>(0)
    const { state } = useLocation()
    useEffect(() => {
        if (state && state.servicePackage) {
            const newPlans: IPlan[] = []
            plans.map((item) => {
                if (state.servicePackage === item.servicePackage) {
                    newPlans.push({ ...item, selected: true })
                } else {
                    newPlans.push(item)
                }
            })
            setPlans(newPlans)
        }
    }, [state])
    const handleSelectPlan = (id: number) => {
        const newPlans = [...plans]
        newPlans.map((item) =>
            item.id === id ? (item.selected = true) : (item.selected = false)
        )
        setPlans(newPlans)
        setSelectedPlan(id)
    }
    return { plans, handleSelectPlan, selectedplan }
}
